<template>
  <div
    style="
      border-radius: 8px;
      border: 1px solid rgb(204, 204, 204);
      box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px;
      background-color: rgb(255, 255, 255);
    "
  >
    <div class="col-12 col-md-12 p-3" style="direction: ltr">
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0">
          <div
            class="row justify-content-center"
            style="direction: rtl; text-align: right; font-size: 16px"
          >
            <div class="col-1 chart-share-icon"></div>
            <div
              class="col-11 mb-3 p-0"
              style="line-height: 2rem; font-weight: bold; color: #000"
            >
              لینک اختصاصی چارت
            </div>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-12 col-md-8 p-0 share-link-box">
          {{ getLink(data['link']) }}
        </div>
        <div class="col-12 col-md-3 p-0 m-md-0 mt-3">
          <div id="link-btn" @click="clickLink(getLink(data['link']))" class="chart-link-btn mr-auto mx-auto">
            <span class="p-1" id="link-btn-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-clipboard"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                ></path>
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                ></path>
              </svg>
            </span>
            <span class="p-1" id="link-btn-text">کپی</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperLib from './helper'

export default {
  name: 'ShareLinkFree',
  props: ['data'],
  methods: {
    closeShareBox() {
      setTimeout(function () {
        document.getElementById('share-box').style.transition = '1s all'
        document.getElementById('share-box').style.display = 'none'
      }, 250)
    },
    getLink(link) {
      return HelperLib.createBasicShareLink(link)
    },
    copyToClient(link) {
      if (navigator.clipboard) {
        // console.log(test)
        navigator.clipboard.writeText(link)
      } else {
        let textArea = document.createElement('textarea')
        textArea.value = link
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        return new Promise((res, rej) => {
          document.execCommand('copy') ? res() : rej()
          textArea.remove()
        })
      }
    },
    clickLink(link) {
      this.copyToClient(link)
      document.getElementById('link-btn').style.background = '#339966'
      document.getElementById('link-btn').style.color = '#ffffff'
      document.getElementById('link-btn-icon').style.display = 'none'
      document.getElementById('link-btn-text').innerHTML = '!کپی شد'
      setTimeout(function () {
        document.getElementById('link-btn').style.background = '#fff'
        document.getElementById('link-btn').style.color = '#000000'
        document.getElementById('link-btn-icon').style.display = 'inline'
        document.getElementById('link-btn-text').innerHTML = 'کپی'
      }, 3000)
    },
  },
}
</script>

<style scoped>
.chart-link-btn {
  text-align: center;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  line-height: 50px;
  width: 100px;
  cursor: pointer;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
  transition: all 1s;
}

.chart-link-btn:hover {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}


.share-link-box {
  background: #f9f9f9;
  border: 1px solid rgba(238, 238, 238, 0.5);
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  height: 50px;
  font-size: 16px;
  flex: 1 1 0%;
  text-align: center;
  line-height: 49px;
  font-weight: bold;
  overflow: hidden;
}

@keyframes fade {
  100% {
    opacity: 1;
  }
  0% {
    opacity: 0;
  }
}
</style>
